<template>
  <modal
    name="property-edit-availability"
    :classes="'customModal'"
    :scrollable="true"
    :reset="true"
    :adaptive="false"
    :width="1050"
    height="auto"
    :clickToClose="false"
  >
    <div class="modalWrapper">
      <div class="form-row mb-4">
        <div class="col-md-5">
          <div class="content__box">
            <div class="content__box__body">
              <div class="top__filter">
                <ul class="top__filter__ul mb-3">
                  <li class="mb-0">Availability</li>
                </ul>
              </div>
              <div class="row align-items-center">
                <div class="col-sm-6">
                  <app-toggle
                    :checked="availability.available == 1 ? true : false"
                    @update:checked="getCheckedStatus($event, 'availability_change')"
                    label="Open 24/7"
                  ></app-toggle>
                </div>
                <div class="col-sm-6 mt-3 mt-sm-0">
                  <app-toggle
                    :checked="availability.monthly_customer == 1 ? true : false"
                    @update:checked="getCheckedStatus($event, 'monthly_customer')"
                    label="Permit Customers Only"
                  ></app-toggle>
                </div>
                <div class="col-sm-12 mt-3 mt-sm-3">
                  <app-toggle
                    :checked="availability.hide_from_search == 1 ? true : false"
                    @update:checked="getCheckedStatus($event, 'hide_from_search')"
                    label="Private Property"
                  ></app-toggle>
                </div>
              </div>
            </div>
          </div>

          <div v-if="availability.available != 1" class="content__box mt-4">
            <div class="content__box__body">
              <div class="top__filter">
                <ul class="top__filter__ul">
                  <li class="mb-0 txt--semi-bold">Hours</li>
                </ul>
              </div>
              <div
                v-for="(days, index) in availability.overnight"
                :key="index"
                class="row align-items-center"
              >
                <div class="col-6 col-sm-5 col-lg-7 mt-3">
                  <app-toggle
                    :checked="days.status == 1 ? true : false"
                    @update:checked="getCheckedStatus($event, static_days[index])"
                    :label="static_days[index]"
                  ></app-toggle>
                </div>
                <div class="col-6 col-sm-7 col-lg-5 mt-3">
                  <div class="row" v-if="days.status">
                    <div class="col-sm-6">
                      <div class="d-flex align-items-center">
                        <p class="txt--xs txt--off-white">Open</p>
                        <datetime
                          title="Open Time"
                          class="dateTime__picker"
                          type="time"
                          value-zone="local"
                          :input-class="['hidden_input', 'hidden_input__md']"
                          v-model="days.min_time_formated"
                        ></datetime>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="d-flex align-items-center">
                        <p class="txt--xs txt--off-white">Close</p>
                        <datetime
                          title="Close Time"
                          class="dateTime__picker"
                          type="time"
                          :input-class="['hidden_input', 'hidden_input__md']"
                          value-zone="local"
                          v-model="days.max_time_formated"
                        ></datetime>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-7 mt-4 mt-md-0">
          <div class="content__box mb-3">
            <div class="content__box__header">
              <div class="top__filter">
                <ul class="top__filter__ul">
                  <li class="mb-0 txt--semi-bold">Holidays</li>
                </ul>
                <ul class="top__filter__ul">
                  <li class="mb-0"  @click="getNewHoliday()">Add Custom Holiday</li>
                </ul>
              </div>
            </div>
            <div class="content__divider"></div>
            <div class="content__box__body holiday__list pt-0">
              <div class="form-row mt-3 mb-3 align-items-center">
                <div class="col-lg-3 txt--off-white txt--semi-bold txt--ss">Name</div>
                <div class="col-lg-5 txt--off-white txt--semi-bold txt--ss">Schedule</div>
                <div class="col-lg-3 txt--off-white txt--semi-bold txt--ss">Parking</div>
                <div class="col-lg-1 txt--off-white txt--semi-bold txt--ss">Status</div>
              </div>
              <div
                class="form-row align-items-center"
                :class="{'mt-4': index !== 0}"
                v-for="(holiday, index) in availability.holidays"
                :key="index"
              >
                <div class="col-lg-3">
                  <p
                    class="mb-2 txt-ss"
                    :class="{'txt--off-dark-white': holiday.status != 1, 'txt--off-white': holiday.status == 1}"
                    style="font-size: 12px">
                    {{ holiday.name }}
                  </p>

                  <!-- <span class=" ml-2 text-white txt--ss opacity--50" v-if="holiday.status == 1">
                    <input type="checkbox"
                     v-model="holiday.payble_status"
                     :checked="holiday.payble_status"
                     @change="updatePaybleStatus($event,holiday)"
                     > <span class="ml-2">Paid</span>
                  </span> -->
                </div>
                <div class="col-lg-5 mt-2 mt-lg-0">
                  <div>
                    <div class="form-row mb-1">
                      <div class="d-flex align-items-center" style="height: 22px">
                        <p
                          class="txt--xs pr-1"
                          :class="{'txt--off-dark-white': holiday.status != 1, 'txt--off-white': holiday.status == 1}"
                        >Start:</p>
                        <datetime
                            v-if="!!holiday.status"
                            title="Closed Date"
                            class="dateTime__picker"
                            :format="{ year:'numeric', month: 'short', day: 'numeric' }"
                            :input-class="['hidden_input', 'hidden_input__lg']"
                            :min-datetime="minDatetime"
                            value-zone="local"
                            v-model="holiday.close_date"
                            :disabled="holiday.holiday_type == 'default' && holiday.identifier"
                          ></datetime>
                          <datetime
                            v-if="!!holiday.status"
                            title="Closed Time"
                            class="dateTime__picker"
                            type="time"
                            :input-class="['hidden_input', 'hidden_input__md']"
                            value-zone="local"
                            v-model="holiday.close_time"
                          ></datetime>
                        <p v-if="!holiday.status" class="txt-ss txt--off-dark-white">-</p>
                      </div>
                    </div>
                    <div class="form-row mb-1">
                        <div class="d-flex align-items-center" style="height: 22px">
                          <p
                            class="txt--xs pr-1"
                            :class="{'txt--off-dark-white': holiday.status != 1, 'txt--off-white': holiday.status == 1}"
                          >Finish:</p>
                          <datetime
                            v-if="!!holiday.status"
                            title="Reopen Date"
                            class="dateTime__picker"
                            :format="{year:'numeric', month: 'short', day: 'numeric' }"
                            :input-class="['hidden_input', 'hidden_input__lg']"
                            :min-datetime="minDatetime"
                            value-zone="local"
                            v-model="holiday.reopen_date"
                            :disabled="holiday.holiday_type == 'default' && holiday.identifier"
                          ></datetime>
                          <datetime
                            v-if="!!holiday.status"
                            title="Reopen Time"
                            class="dateTime__picker"
                            type="time"
                            :input-class="['hidden_input', 'hidden_input__md']"
                            value-zone="local"
                            v-model="holiday.reopen_time"
                          ></datetime>
                          <p v-if="!holiday.status" class="txt-ss txt--off-dark-white">-</p>
                        </div>
                    </div>
                    <div v-if="holiday.holiday_type == 'custom'" class="form-row mb-1">
                      <div class="col-sm-12">
                        <div class="d-flex justify-content-end mr-4">
                          <div
                            class="opacity--25 cursor-pointer txt--xs"
                            @click="removeHoliday(index)"
                          >Remove</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3">
                  <TextToggle
                    :disabled="!holiday.status"
                    :leftItem="{ name: 'Closed', value: 0 }"
                    :rightItem="{ name: 'Free', value: 1 }"
                    v-model="holiday.free_parking"
                  />
                </div>
                <div class="col-lg-1">
                  <app-toggle
                    class="mb-2"
                    :checked="holiday.status == 1 ? true : false"
                    @update:checked="updateHolidayStatus($event, holiday)"
                  ></app-toggle>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
      v-if="user_role == 'commercial' || (user_role == 'operator' && access_list.permit_access_write == true)"
      class="form-row">
        <div class="col-12">
          <div class="d-flex justify-content-center flex-wrap">
            <ButtonWithSpinner
              class="button button--primary button--sm mr-3"
              :loading="button.loading"
              :success="button.success"
              :disabled="button.disabled"
              @click="saveAvailability"
              >Save</ButtonWithSpinner
            >
            <button
              type="button"
              class="button button--outline button--sm"
               @click="closeModal()"
            >Cancel</button>
          </div>
        </div>
      </div>
      <div class="session__modal__close"  @click="closeModal()">
        <i class="fas fa-times"></i>
      </div>
    </div>
  </modal>
</template>

<script>
import Toggle from "@/components/toggle";
import { Datetime } from "vue-datetime";
import TextToggle from "../TextToggle.vue";
import ButtonWithSpinner from "@/components/Button";
import "vue-datetime/dist/vue-datetime.css";

export default {
  name: "EditPropertyAvailability",
  props: ["property_details"],
  data() {
    return {
      space_id: null,
      minDatetime: "2020-01-01T16:32:49.145+05:30",
      static_days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      availability: {
        overnight_status: 1,
        overnight: [
          {
            day: "sun",
            max_time: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            max_time_formated: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            min_time: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            min_time_formated: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            status: 0,
          },
          {
            day: "mon",
            max_time: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            max_time_formated: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            min_time: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            min_time_formated: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            status: 0,
          },
          {
            day: "tue",
            max_time: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            max_time_formated: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            min_time: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            min_time_formated: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            status: 0,
          },
          {
            day: "wed",
            max_time: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            max_time_formated: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            min_time: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            min_time_formated: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            status: 0,
          },
          {
            day: "thu",
            max_time: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            max_time_formated: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            min_time: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            min_time_formated: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            status: 0,
          },
          {
            day: "fri",
            max_time: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            max_time_formated: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            min_time: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            min_time_formated: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            status: 0,
          },
          {
            day: "sat",
            max_time: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            max_time_formated: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            min_time: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            min_time_formated: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            status: 0,
          },
        ],
        start_date: "",
        end_date: "",
        available: 1,
        monthly_customer: 0,
        // NOTE: default holidays will now be provided by the backend.
        holidays: [],
        // holidays: [
        //   createDefaultHoliday("New Year's Day", "new_years_day", {
        //     close_date: "1 january",
        //     reopen_date: "2 january"
        //   }),
        //   createDefaultHoliday("Christmas Day", "christams_day", {
        //     close_date: "25 december",
        //     reopen_date: "26 december"
        //   }),
        //   createDefaultHoliday("MLK Day", "mlk_day", {
        //     close_date: "second monday january",
        //     reopen_date: "second monday january + 1 day"
        //   }),
        //   createDefaultHoliday("Memorial Day", "memorial_day", {
        //     close_date: "third monday may",
        //     reopen_date: "third monday may + 1 day"
        //   }),
        //   createDefaultHoliday("Independence Day", "independence_day", {
        //     close_date: "11 july",
        //     reopen_date: "12 july"
        //   }),
        //   createDefaultHoliday("Labor Day", "labor_day", {
        //     close_date: "previous monday september",
        //     reopen_date: "previous monday september + 1 day"
        //   }),
        //   createDefaultHoliday("Veterans Day", "veterans_day", {
        //     close_date: "11 november",
        //     reopen_date: "12 november"
        //   }),
        //   createDefaultHoliday("Thanksgiving Day", "thanksgiving_day", {
        //     close_date: "third thursday november",
        //     reopen_date: "third thursday november + 1 day"
        //   }),
        //   createDefaultHoliday("Day after Thanksgiving", "day_after_thanksgiving", {
        //     close_date: "third thursday november + 1 day",
        //     reopen_date: "third thursday november + 2 days"
        //   }),
        //   createDefaultHoliday("President's Day", "presidents_day", {
        //     close_date: "second monday february",
        //     reopen_date: "second monday february + 1 day"
        //   }),
        // ],
        hide_from_search : 0,
      },
      button: {
        loading: false,
        success: false,
        disabled: false,
      },
      user_role:    '',
      access_list:  {},
    };
  },
  components: {
    ButtonWithSpinner,
    AppToggle: Toggle,
    datetime: Datetime,
    TextToggle,
  },
  watch: {
    property_details: function () {
      this.getPropertyAvailabilty();
    },
  },
  created() {
    this.user_role    = localStorage.getItem("role");
    this.access_list  = JSON.parse(localStorage.getItem("commercial_access_list"));
    this.getPropertyAvailabilty();
  },
  computed: {
    computeModalWidth() {
      if (this.$mq === "lg") return "900px";
      else return "400px";
    },
  },
  methods: {
    getPropertyAvailabilty() {
      this.space_id = this.property_details.space_id;
      this.availability.start_date = this.property_details.availability.start_date? this.property_details.availability.start_date : this.$moment().format("YYYY-MM-DD");
      this.availability.end_date = this.property_details.availability.end_date;
      this.availability.overnight_status = this.property_details.availability.available == 1 ? 0 : 1;
      this.availability.monthly_customer = this.property_details.availability.monthly_customer ;
      this.availability.hide_from_search = this.property_details.availability.hide_from_search;
      this.availability.available = this.property_details.availability.available;
      this.availability.overnight = this.property_details.availability.overnight;

      this.availability.overnight.map((val,index) => {

        let date = this.$moment().format("YYYY-MM-DD");
        let open_date = null;
        let close_date = null;

        // Convert Open Time To 9:00 AM And Close Time To 6:00 PM.
        if((val.min_time_formated!=null && val.max_time_formated!=null) || (val.min_time_formated!=undefined && val.max_time_formated!=undefined) || (val.min_time_formated!='' && val.max_time_formated!='')) {
          open_date = date+' '+val.min_time_formated;
          close_date = date+' '+val.max_time_formated;
        }
        else {
          open_date = date+' 09:00:00';
          close_date = date+' 18:00:00';
        }
        
        this.availability.overnight[index].max_time = this.$moment(close_date).format("YYYY-MM-DDTHH:mm:ss.sssZ");
        this.availability.overnight[index].max_time_formated = this.$moment(close_date).format("YYYY-MM-DDTHH:mm:ss.sssZ");
        this.availability.overnight[index].min_time = this.$moment(open_date).format("YYYY-MM-DDTHH:mm:ss.sssZ");
        this.availability.overnight[index].min_time_formated = this.$moment(open_date).format("YYYY-MM-DDTHH:mm:ss.sssZ");
      });
      // console.log(this.availability.holidays);
      this.availability.holidays.map(val=>{
        // console.log(val);
        val.close_date = this.$moment(val.close_date).format("YYYY-MM-DDTHH:mm:ss.sssZ");
        let h = val.close_time.split(":")[0];
        let m = val.close_time.split(":")[1];
        let d = new Date(val.close_date).setHours(h, m);
        val.close_time = this.$moment(d).format("YYYY-MM-DDTHH:mm:ss.sssZ");
        val.reopen_date = this.$moment(val.reopen_date).format("YYYY-MM-DDTHH:mm:ss.sssZ");
        let h1 = val.reopen_time.split(":")[0];
        let m1 = val.reopen_time.split(":")[1];
        let d1 = new Date(val.reopen_date).setHours(h1, m1);
        val.reopen_time = this.$moment(d1).format("YYYY-MM-DDTHH:mm:ss.sssZ");
      });
      
      this.property_details.availability.holiday.map((val)=> {
        if(['dafault', 'default'].includes(val.holiday_type)) {
          let default_holiday = {
            'name': val.name,
            'status': val.status,
            'holiday_type': 'default',
            'close_date':  this.$moment(val.close_date).format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            'close_time': this.$moment(val.close_date_time).format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            'reopen_date': this.$moment(val.reopen_date).format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            'reopen_time': this.$moment(val.reopen_date_time).format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            'free_parking': val.free_parking
          }

          if (val.identifier) {
            default_holiday.identifier = val.identifier;
          }

          this.availability.holidays.push(default_holiday);
        }
        if(val.holiday_type == 'custom') {
          let custom_holiday = {
            'name': val.name,
            'status': val.status,
            'holiday_type': 'custom',
            'close_date':  this.$moment(val.close_date).format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            'close_time': this.$moment(val.close_date_time).format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            'reopen_date': this.$moment(val.reopen_date).format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            'reopen_time': this.$moment(val.reopen_date_time).format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            'free_parking'  :val.free_parking
          }
          this.availability.holidays.push(custom_holiday);
        }
      });

    },
    getCheckedStatus(event, status)  {
      if(status == 'availability_change') {
        this.availability.available = event ? 1 : 0;
        this.availability.overnight_status = !this.availability.available;
      }
      else if(status == 'monthly_customer') {
        this.availability.monthly_customer = event ? 1 : 0;
      }
      else if(status == 'hide_from_search') {
        this.availability.hide_from_search = event ? 1 : 0;
      }
      else {
        if (this.static_days.indexOf(status) != -1) {
          let key = this.static_days.indexOf(status) ;
          let prev_key = '' ;
          if(key >= 0 && event) {
            let l = key == 0 ? this.availability.overnight.length : key ;
            for(let i=0;i<l;i++) {
              if(this.availability.overnight[i].status == 1 || this.availability.overnight[i].status == '1') {
                prev_key = i ;
              }
            }
            if(prev_key>= 0 && this.availability.overnight[prev_key]!=undefined) {
              let overnight = {
                'day':this.availability.overnight[key].day,
                'status':this.availability.overnight[prev_key].status,
                'min_time':this.availability.overnight[prev_key].min_time,
                'max_time':this.availability.overnight[prev_key].max_time,
                'min_time_formated':this.availability.overnight[prev_key].min_time_formated,
                'max_time_formated':this.availability.overnight[prev_key].max_time_formated,
              };
              this.$set(this.availability.overnight,key,JSON.parse(JSON.stringify(overnight)));
            }
            else {
              this.availability.overnight[this.static_days.indexOf(status)].status = event ? 1 : 0;
            }
          }
          else {
            this.availability.overnight[this.static_days.indexOf(status)].status = event ? 1 : 0;
          }
        }
      }
    },
    updateHolidayStatus(payload, holiday) {
      holiday.status = payload;
    },
    async getNewHoliday(){
      const { value: custom_holiday } = await this.$swal({
        title: "Enter Holiday Name",
        input: "text",
        inputValue: "custom-holiday",
        inputPlaceholder: "Enter holiday name",
        showCancelButton: true,
        inputValidator: (value) => {
          if (!value) {
            return "Please type a holiday name!";
          }
        },
      });

      let h_d = this.$moment(new Date()).format("YYYY-MM-DDTHH:mm:ss.sssZ");
      let d = new Date(h_d).setHours(10, 0);
      if (custom_holiday) {
        this.availability.holidays.push({
          holiday_type: "custom",
          name: custom_holiday,
          close_date: this.$moment(d).format("YYYY-MM-DDTHH:mm:ss.sssZ"),
          close_time: this.$moment(d).format("YYYY-MM-DDTHH:mm:ss.sssZ"),
          reopen_date: this.$moment(d).add(1,'days').format("YYYY-MM-DDTHH:mm:ss.sssZ"),
          reopen_time: this.$moment(d).add(1,'days').format("YYYY-MM-DDTHH:mm:ss.sssZ"),
          status: 1,
          free_parking  :false,
          // payble_status:false
        });
      }
    },
    removeHoliday(index) {
      this.$delete(this.availability.holidays, index);
    },
    closeModal() {
      this.$emit("modal_closed");
      this.$modal.hide("property-edit-availability");
    },
    saveAvailability() {
      //validate data
      // console.log(this.availability.holidays);
      if (this.availability.overnight_status == 1) {
        
        let is_active = false;
        let error = false;
        this.availability.overnight.map((val,index) => {
          
          if (val.status == 1) {

            let open_time = this.$moment(val.min_time_formated);
            let close_time = this.$moment(val.max_time_formated);

            if(open_time.format("YYYY-MM-DD HH:mm") == 'Invalid date') {
              this.$toasted.show(`Open time for ${this.static_days[index]} is required!`,{
                icon: 'times-circle',
                className: 'error-class'
              });
              error = true;
              return false;
            }
            
            if(close_time.format("YYYY-MM-DD HH:mm") == 'Invalid date') {
              this.$toasted.show(`Close time for ${this.static_days[index]} is required!`,{
                icon: 'times-circle',
                className: 'error-class'
              });
              error = true;
              return false;
            }

            if(open_time.diff(close_time) > 0) {
              this.$toasted.show(`Open time for ${this.static_days[index]} can not be greater than Close time!`,{
                icon: 'times-circle',
                className: 'error-class'
              });
              error = true;
              return false;
            }

            is_active = true;
          }
        });

        if(error) return;

        if (!is_active) {
          this.$toasted.show("Please select at least one day if property is not opened for 24/7!", {
              icon: "times-circle",
              className: "error-class",
            });
          return;
        }
      }

      let h_error = false;
      this.availability.holidays.map((val)=> {
        if(val.status == 1) {
          let start_time = this.$moment(val.close_time);
          let end_time = this.$moment(val.reopen_time);
          if(start_time.diff(end_time) >= 0) {
            this.$toasted.show(`Close time of ${val.name} can not be greater than Reopen time!`,{
              icon: 'times-circle',
              className: 'error-class'
            });
            h_error = true;
            return false;
          }
          if(start_time.format("YYYY-MM-DD HH:mm") == 'Invalid date') {
            this.$toasted.show(`Close time of ${val.name} is required!`,{
              icon: 'times-circle',
              className: 'error-class'
            });
            h_error = true;
            return false;
          }
          if(end_time.format("YYYY-MM-DD HH:mm") == 'Invalid date') {
            this.$toasted.show(`Reopen time of ${val.name} is required!`,{
              icon: 'times-circle',
              className: 'error-class'
            });
            h_error = true;
            return false;
          }
        }
        
      });

      if(h_error) return;

      let requestData = {};
      requestData.available = this.availability.available;
      requestData.overnight_status = this.availability.overnight_status;
      requestData.start_date = this.availability.start_date;
      requestData.monthly_customer = this.availability.monthly_customer;
      requestData.hide_from_search = this.availability.hide_from_search ;
      requestData.overnight = JSON.parse(JSON.stringify(this.availability.overnight));

      for (let i = 0; i < requestData.overnight.length; i++)  {
        if(requestData.overnight[i].status == 1) {
          requestData.overnight[i].max_time = parseInt(this.$moment(requestData.overnight[i].max_time_formated).format("HH"));
          requestData.overnight[i].max_time_formated = this.$moment(this.availability.overnight[i].max_time_formated).format("HH:mm");
          requestData.overnight[i].min_time = parseInt(this.$moment(this.availability.overnight[i].min_time_formated).format("HH"));
          requestData.overnight[i].min_time_formated = this.$moment(this.availability.overnight[i].min_time_formated).format("HH:mm");

        }
        else {
          requestData.overnight[i].max_time = null;
          requestData.overnight[i].max_time_formated = null;
          requestData.overnight[i].min_time = null;
          requestData.overnight[i].min_time_formated = null;
        }
      }

      requestData.holiday = JSON.parse(JSON.stringify(this.availability.holidays));
      // console.log(requestData);
      for (let i = 0; i < requestData.holiday.length; i++) {
        if(requestData.holiday[i].status == 1) {
          requestData.holiday[i].close_date     = this.$moment(requestData.holiday[i].close_date).format("YYYY-MM-DD");
          requestData.holiday[i].close_time     = this.$moment(requestData.holiday[i].close_time).format("HH:mm");
          requestData.holiday[i].reopen_date    = this.$moment(requestData.holiday[i].reopen_date).format("YYYY-MM-DD");
          requestData.holiday[i].reopen_time    = this.$moment(requestData.holiday[i].reopen_time).format("HH:mm");
          // requestData.holiday[i].payble_status  = this.requestData.holiday[i].payble_status;
        }
        else {
          requestData.holiday[i].close_date     = null;
          requestData.holiday[i].close_time     = null;
          requestData.holiday[i].reopen_date    = null;
          requestData.holiday[i].reopen_time    = null;
          // requestData.holiday[i].payble_status  = false; 
        }
      }
      requestData.mode = "availability";
      requestData.device_type = 1;
      requestData.space_id = this.space_id;
      requestData.commercial = 1;

      this.button.disabled = true;
      this.button.loading = true;
      this.axios
        .post(window.hostname + "api/auth/create-space", requestData)
        .then((res) => {
          if (res.data.status) {
            this.$toasted.show("Property details updated successfully!", {
              icon: "check-circle",
              className: "success-class",
            });
            this.button.disabled = false;
            this.button.loading = false;
            this.button.success = true;

            setTimeout(() => {
              this.button.disabled = false;
              this.button.loading = false;
              this.button.success = false;
              this.closeModal();
            }, 2000);
            
          } else {
            this.button.disabled = false;
            this.button.loading = false;
            this.button.success = false;
            this.$toasted.show(res.data.message, {
              icon: "times-circle",
              className: "error-class",
            });
          }
        })
        .catch((err) => {
          this.button.disabled = false;
          this.button.loading = false;
          this.button.success = false;
          console.log(err);
          this.$toasted.show("Something went wrong. Please try again!", {
            icon: "times-circle",
            className: "error-class",
          });
        });
    },
    updatePaybleStatus(payload,holiday){
      // holiday.payble_status =holiday.payble_status;
      // console.log(payload);
      // console.log(holiday);
    }
  },
};
</script>

<style>
.vm--overlay {
  background: rgba(0, 0, 0, 0.9) !important;
}
</style>
